import { useState, useEffect } from "react";


const sections = ["Home", "Sobre", "Coleção", "Equipe", "Contato", "Board", "Info"];

export default function Sidebar() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = document.querySelectorAll("section");
      let index = 0;

      sectionElements.forEach((section, i) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2) {
          index = i;
        }
      });

      setActiveIndex(index);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (index) => {
    document.querySelectorAll("section")[index].scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div className="sidebar">
      {sections.map((_, index) => (
        <div key={index} className="sidebar-item">
          <button
            onClick={() => scrollToSection(index)}
            className={`sidebar-number ${index === activeIndex ? "active" : ""}`}
          >
            {index + 1}
          </button>
          {/* Linha conectando os números */}
          {index < sections.length - 1 && (
            <div className={`sidebar-line ${index === activeIndex ? "active-line" : ""}`}></div>
          )}
        </div>
      ))}
    </div>
  );
}